import { useQuery, UseQueryResult } from 'react-query';

import { V2CreationData } from '@/apis/aniftyBackend/creations/interface';
import v2FetchCreationByID from '@/apis/aniftyBackend/creations/v2FetchCreationByID';

export const createQueryKey = (creationID: number) =>
  ['/v2/creations', creationID] as const;

type UseV2FetchCreationByID = (
  creationID: number | undefined,
  options: { initialData?: V2CreationData }
) => UseQueryResult<V2CreationData>;

const useV2FetchCreationByID: UseV2FetchCreationByID = (
  creationID,
  { initialData } = {}
) => {
  return useQuery({
    queryKey: creationID ? createQueryKey(creationID) : undefined,
    queryFn: creationID ? () => v2FetchCreationByID(creationID) : undefined,
    enabled: !!creationID,
    initialData,
  });
};

export default useV2FetchCreationByID;
